import { Typography, Link } from '@one-thd/sui-atomic-components';
import React, { useEffect } from 'react';
import { goToPreviousStep } from '../../stores/flowStore';
import { REFUND_TIMING_MESSAGE } from '../../constants';
import { ReturnButtons } from '../shared/ReturnButtons';
import { disableAbandonmentSurvey } from '../../utils/storage-helper';
import { useReturnStore } from '../../stores/returnStore';
import { redirectToOrderDetails } from '../../utils/general';
import { TagReturnMethodInStore } from '../../utils/analytics-tagging';
export var LegacyInStoreReturnMethod = function () {
    var orderDetailsV2 = useReturnStore(function (state) { return state.orderDetailsV2; });
    var isMilitaryExchangeGuest = useReturnStore(function (state) { return state.isMilitaryExchangeGuest; });
    var militaryExchange = useReturnStore(function (state) { return state.militaryExchange; });
    var orderDetailsPath = useReturnStore(function (state) { return state.orderDetailsPath; });
    useEffect(function () {
        disableAbandonmentSurvey();
        if (orderDetailsV2) {
            TagReturnMethodInStore(orderDetailsV2, militaryExchange);
        }
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-3" },
            React.createElement(Typography, { weight: "bold" }, "In-Store Drop-Off Instructions"),
            React.createElement(Typography, null,
                "If you want to return an item, bring it to any",
                ' ',
                React.createElement(Link, { href: "https://www.homedepot.com/l/", target: "_blank" }, "Home Depot store"),
                ' ',
                "to our returns or customer service counter."),
            React.createElement(Typography, null, "Bring your receipt or the original card used for the purchase."),
            React.createElement(Typography, null, REFUND_TIMING_MESSAGE),
            React.createElement(ReturnButtons, { proceedNext: function () {
                    return redirectToOrderDetails(orderDetailsPath, isMilitaryExchangeGuest);
                }, proceedBack: function () {
                    goToPreviousStep('ReturnMethod');
                }, instore: true }))));
};
